/* NOOT — Size Chart pop-up (native <dialog>: closes with Esc, the X, or a tap outside). */
if (!customElements.get('size-chart-dialog')) {
  customElements.define(
    'size-chart-dialog',
    class SizeChartDialog extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.querySelector('[data-size-chart-close]').addEventListener('click', () => this.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close(); // tap on the dark area
        });
        this.dialog.addEventListener('close', () => document.body.classList.remove('overflow-hidden'));
      }

      open() {
        this.highlightSelectedSize();
        this.dialog.showModal();
        document.body.classList.add('overflow-hidden');
      }

      close() {
        this.dialog.close();
      }

      highlightSelectedSize() {
        const picker = document.getElementById(`variant-selects-${this.dataset.section}`);
        let selected = null;
        if (picker) {
          picker.querySelectorAll('fieldset, .product-form__input').forEach((group) => {
            const label = group.querySelector('legend, label');
            if (!label || !/size|مقاس/i.test(label.textContent)) return;
            const checked = group.querySelector('input:checked');
            const select = group.querySelector('select');
            selected = checked ? checked.value : select ? select.value : null;
          });
        }
        // General chart: sizes are rows. Product charts: sizes are columns (header + cells).
        this.querySelectorAll('[data-size]').forEach((el) => {
          el.classList.toggle('is-selected', !!selected && el.dataset.size === selected);
        });
      }
    }
  );
}
